import { FormsTable } from 'components';

export default function Processed() {
  return <FormsTable persistentListParametersStateKey='processed' title='Processed' />;
}
